import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_icon_alarm = _resolveComponent("icon-alarm");
    return (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", null, [
                _createVNode(_component_icon_alarm, {
                    class: "mr-1",
                    style: { "height": "16px", "width": "16px" }
                }),
                _createTextVNode(_toDisplayString(_ctx.remainingTime), 1)
            ])
        ]))
        : _createCommentVNode("", true);
}
